import { render, staticRenderFns } from "./shape-popup.vue?vue&type=template&id=554eb9c4&"
import script from "./shape-popup.vue?vue&type=script&lang=js&"
export * from "./shape-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports